import type { PropsWithChildren, ReactNode } from 'react';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { BasePlate, BasePlateHeader, BasePlateFooter } from '@evrone-erp/uikit';
// TODO: make props accessible from the package root path
import type { BasePlateHeaderProps } from '@evrone-erp/uikit/dist/components/base-plate/BasePlateHeader';
import { PageTitle } from '@shared/ui/page-title/PageTitle';
import { styles } from './styles';

// TODO: if component will be used outside repo - move to frontend-shared/ui-kit

export type TPlateFormContainerProps = {
  formTitle?: string;
  formTitleVariant?: Parameters<typeof Typography>[0]['variant'];
  backHref?: string;
  headerTitle: BasePlateHeaderProps['title'];
  headerSubtitle?: BasePlateHeaderProps['subtitle'];
  headerLink?: BasePlateHeaderProps['link'];
  errorContent?: string | ReactNode;
  footerPrimaryAction?: JSX.Element;
  footerSecondaryAction?: JSX.Element;
};
export const PlateFormContainer = ({
  formTitle,
  formTitleVariant,
  backHref,
  headerTitle,
  headerSubtitle,
  headerLink,
  errorContent,
  children,
  footerPrimaryAction,
  footerSecondaryAction
}: PropsWithChildren<TPlateFormContainerProps>) => <Box>
    {formTitle && <PageTitle sx={styles.header} backHref={backHref} typographyVariant={formTitleVariant}>
        {formTitle}
      </PageTitle>}
    <BasePlate sx={styles.plate}>
      <Box sx={styles.innerHeaderAndError}>
        <BasePlateHeader link={headerLink} title={headerTitle} subtitle={headerSubtitle} />
        <Typography variant="text" sx={styles.errorText}>
          {errorContent}
        </Typography>
      </Box>
      <Box sx={styles.content}>{children}</Box>
      {footerPrimaryAction && <BasePlateFooter sx={styles.footer} primaryAction={footerPrimaryAction} secondaryAction={footerSecondaryAction} />}
    </BasePlate>
  </Box>;